import React, { useEffect, useState } from 'react';
import Loading from '../../loading/Loading';
import TableLayout, { TD, selectSx } from '../../ui/TableLayout';
import { EditBtn, DeleteBtn, Actions } from '../../ui/ActionButtons';
import Apis from '../../Apis';
import axios from 'axios';

const COLS = ['Produto', 'Unidade', 'Preço', 'Estoque', 'Status', 'Ações'];
const headers = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });

export default function ListaProdutos() {
  const [search, setSearch]   = useState('');
  const [status, setStatus]   = useState('');
  const [perPage, setPerPage] = useState(25);
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = (s = status, pp = perPage, q = search) => {
    setLoading(true);
    const body = { pesquisa: q, qtd_registros: pp };
    if (s !== '') body.status = s;
    axios.post(Apis.urlListarProdutos, body, { headers: headers() })
      .then(res => setData(res.data.registros || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, []); // eslint-disable-line

  const handlePerPage = (val) => { setPerPage(val); fetchData(status, val); };

  const Toolbar = (
    <select value={status} onChange={e => { const v = e.target.value; setStatus(v); fetchData(v); }} style={selectSx}>
      <option value="">Todos os status</option>
      <option value="0">Ativos</option>
      <option value="1">Inativos</option>
    </select>
  );

  if (loading) return <Loading />;

  return (
    <TableLayout
      title="Lista de Produtos"
      icon={null}
      count={data.length}
      columns={COLS}
      search={{ value: search, onChange: setSearch, placeholder: 'Buscar por descrição…', onSubmit: () => fetchData() }}
      pagination={{ value: perPage, onChange: handlePerPage }}
      toolbar={Toolbar}
      fab={{ show: true, label: 'produto', path: 'cadastrar-produtos' }}
      emptyMessage="Nenhum produto encontrado para os filtros aplicados."
    >
      {data.map((c, i) => {
        const ativo = String(c.status) === '0';
        return (
          <tr key={c.id}
            style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#eff6ff')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc')}
          >
            <TD left uppercase>{c.descricao}</TD>
            <TD>{c.sigla}</TD>
            <TD>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#10b981' }}>R$ {c.preco}</span>
            </TD>
            <TD>{c.estoque}</TD>
            <TD>
              <span style={{
                display: 'inline-block', padding: '2px 12px', borderRadius: 40,
                background: ativo ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)',
                color: ativo ? '#059669' : '#dc2626',
                fontSize: 11, fontWeight: 600,
              }}>
                {ativo ? 'Ativo' : 'Inativo'}
              </span>
            </TD>
            <TD>
              <Actions>
                <EditBtn to={`/alterar-produto/${c.id}`} />
                <DeleteBtn url={Apis.urlDeletarProdutos} id={c.id} redirect="listar-produtos" component="Produto" texto={`Deseja realmente excluir o produto ${c.descricao}`} />
              </Actions>
            </TD>
          </tr>
        );
      })}
    </TableLayout>
  );
}
